<div [formGroup]="form">
   <label id="kavalli-radio">{{ label }}</label>
   <mat-radio-group [formControlName]="controlName" aria-labelledby="kavalli-radio">
      <mat-radio-button *ngFor="let radio of options" [value]="radio.value">{{
         radio.name
      }}</mat-radio-button>
   </mat-radio-group>
</div>
